import React from "react";
import { Switch, Route, Redirect,BrowserRouter } from "react-router-dom";
import Login from "../../Pages/Login";
import ForgotPassword from "../../Pages/ForgotPassword";
import MultiRestLogin from "../../Components/RestLogin/MultiRestLogin";
import SuperAdminLogin from "../../Components/SuperAdminLogin/SuperAdminLogin";

const AuthRoutes = () => {
  return (
    // <BrowserRouter basename="/v1">
    <Switch>
      {/* <Redirect from="/" to="/login" /> */}
      <Route exact path="/">
        <Redirect to="/login" />
      </Route>
      <Route path="/login" render={(props) => <Login {...props} />} />
      <Route
        path="/login/:userName/:rName"
        render={(props) => <Login {...props} />}
      />
      <Route
        path="/admin-login"
        render={(props) => <SuperAdminLogin {...props} />}
      />
      <Route
        exact
        path="/select-restaurant"
        render={(props) => <MultiRestLogin {...props} />}
      />
      <Route
        exact
        path="/forgot-password"
        render={(props) => <ForgotPassword {...props} />}
      />
      <Redirect from="*" to="/login" />
    </Switch>
    // </BrowserRouter>
  );
};

export default AuthRoutes;
